/* eslint-disable no-console */
// The app used to register a service worker for incoming-call notifications of the phone.
// Remove that registration if it is still installed in the browser, without touching
// service workers of other applications that may share this origin.
const RETIRED_SERVICE_WORKER_URL = `${window.location.origin}/service-worker.js`;

const isRetiredServiceWorker = registration =>
  [registration.active, registration.waiting, registration.installing].some(
    worker => worker?.scriptURL === RETIRED_SERVICE_WORKER_URL,
  );

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations =>
        Promise.all(
          registrations
            .filter(isRetiredServiceWorker)
            .map(registration => registration.unregister()),
        ),
      )
      .catch(error => {
        console.log('Error during unregistering service worker:', error);
      });
  }
}
